import { render, staticRenderFns } from "./mgmtUser.vue?vue&type=template&id=398db32f&scoped=true&lang=html"
import script from "./mgmtUser.vue?vue&type=script&lang=js"
export * from "./mgmtUser.vue?vue&type=script&lang=js"
import style0 from "./mgmtUser.vue?vue&type=style&index=0&id=398db32f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398db32f",
  null
  
)

export default component.exports